import React from 'react';
import { RouteComponentProps, Route, Switch } from 'react-router-dom';
import ListaMonografiasPage from './ListaMonografiasPage';
import AgendamentoBancaPage from './AgendamentoBancaPage';
import DetalhesAlunoPage from './DetalhesAlunoPage';
import DetalhesProfessorPage from './DetalhesProfessorPage';
import PreprojetoPage from './PreProjetoPage'
import ParametrosPreProjetoPage from './ParametrosPreProjetoPage'

const FuncionarioPage: React.FC<RouteComponentProps<string>> = (
  props: RouteComponentProps<string>
) => (
  <Switch>
    <Route
      path={`${props.match.path}/agendamento/:id`}
      component={AgendamentoBancaPage}
    />
    <Route
      path={`${props.match.path}/alunos/:id`}
      component={DetalhesAlunoPage}
    />
    <Route
      path={`${props.match.path}/preprojetos/:id`}
      component={PreprojetoPage}
    />
    <Route
      path={`${props.match.path}/professor/:id`}
      component={DetalhesProfessorPage}
    />
    <Route
      path={`${props.match.path}/parametro/:id`}
      component={ParametrosPreProjetoPage}
    />
    <Route
      path={`${props.match.path}/parametro`}
      component={ParametrosPreProjetoPage}
    />    
    <Route path={props.match.path} component={ListaMonografiasPage} />
  </Switch>
);

export default FuncionarioPage;
